(function( $ ) {
	var $target;
	var $sources;
	var navTarget;
	var total = 0;
	var index = 0;
	var myTimeout = "";

	function setIndices(target,navTarget){
			$sources.each(function (i) {
				$(navTarget).append('<li data-id="'+i+'" href=""></li>');
				total ++;
		});
	}

	function doNextSourceAsDisplay() {
		index ++;
		if (index >= total){
			index = 0;
		}
		//
		loadSourceAsDisplay(index, false);
	}

	function loadSourceAsDisplay(i, isClicked){
		index = i;
		var html = $sources.eq(i).html();
		if (myTimeout != ""){
			clearTimeout(myTimeout);
		}
		//Get the timeout value from the hidden field
		var timeoutValue = Number($sources.eq(i).find('input:hidden').val());
		//If clicked, show content for 1 minute
		if (isClicked){
			timeoutValue = 120000;
		}
		//FOR TESTING PURPOSES REDUCE THE TIME DOWN

		if (timeoutValue >= 1000){
			myTimeout = setTimeout(doNextSourceAsDisplay, timeoutValue);
		}
		$(navTarget).find('li').removeClass('active');
		$(navTarget).find('li[data-id="'+i+'"]').addClass('active');
		$target.children('.news_content').html(html);
	}
	$.fn.l3harrisNewsRotator = function(options) {
		var settings = $.extend({
			navTarget: ".news_rotator_nav ul"}, options );
		$target = this;
		$sources = $target.children('.news_sources').children('div');
		navTarget = settings.navTarget;
		//
		setIndices(this,settings.navTarget);
		$(navTarget).on('click','li', function (e){
			e.preventDefault();
			var i = $(this).data('id');
			loadSourceAsDisplay(i, true);
			return false;
		});
		loadSourceAsDisplay(0, false);
		return this;
	};
}( jQuery ));
